import { render } from "./PointAdjustmentHistory.vue?vue&type=template&id=319007ab&scoped=true"
import script from "./PointAdjustmentHistory.vue?vue&type=script&lang=js"
export * from "./PointAdjustmentHistory.vue?vue&type=script&lang=js"

import "./PointAdjustmentHistory.vue?vue&type=style&index=0&id=319007ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319007ab"]])

export default __exports__